import Dashboard from "../views/Dashboard.vue";
import Disbursement from "../views/Disbursement.vue";
import AgentDisbursement from "../views/AgentDisbursement.vue";
import ListAgentDisbursement from "../views/ListAgentDisburstment.vue";
import DisbursementDetail from "../views/DisbursementDetail.vue";
import IntroducingBroker from "../views/IntroducingBroker/ListIntroducingBroker.vue";
import IntroducingBrokerDetail from "../views/IntroducingBroker/DetailIntroducingBroker.vue";
import ListConfiguration from "../views/Configuration/ListConfiguration.vue";
import AddConfiguration from "../views/Configuration/AddConfiguration.vue";
import UpdateConfiguration from "../views/Configuration/UpdateConfiguration.vue";
import IbRequest from "../views/IB_Request/IbRequest.vue";
import IbUpLevel from "../views/IB_Uplevel/ListIbUplevel.vue";
import Profile from "../views/Profile/Profile.vue";
import UpdateProfile from "../views/Profile/UpdateProfile.vue";
import ChangePassword from "../views/Profile/ChangePassword.vue";
import Bank from "../views/Bank/Bank.vue";
import Rate from "../views/Rate/ListRate.vue"
import UpdateRate from "../views/Rate/UpdateRate.vue"
import AddBank from "../views/Bank/AddBank.vue";
import auth from "../middleware/auth";
import vendor_notcomplete from "../middleware/vendor_notcomplete";

export default [
    {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/ib",
        name: "IntroducingBroker",
        component: IntroducingBroker,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/ib/:id",
        name: "IntroducingBrokerDetail",
        component: IntroducingBrokerDetail,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/configuration",
        name: "ListConfiguration",
        component: ListConfiguration,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/configuration/add",
        name: "AddConfiguration",
        component: AddConfiguration,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/configuration/update/:id",
        name: "UpdateConfiguration",
        component: UpdateConfiguration,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },

    {
        path: "/bank",
        name: "Bank",
        component: Bank,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },

    {
        path: "/add-bank-account",
        name: "AddBank",
        component: AddBank,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/update-profile/:id",
        name: "UpdateProfile",
        component: UpdateProfile,
        meta: {
            middleware: [auth]
        }
    },
    {
        path: "/change-password/:id",
        name: "ChangePassword",
        component: ChangePassword,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/disbursement",
        name: "Disbursement",
        component: Disbursement,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/agent-disbursement",
        name: "AgentDisbursement",
        component: AgentDisbursement,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/agent-disbursement/:id",
        name: "ListAgentDisbursement",
        component: ListAgentDisbursement,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/disbursemet-detail/:id",
        name: "DisbursementDetail",
        component: DisbursementDetail,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/ibrequest",
        name: "IbRequest",
        component: IbRequest,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/ibuplevel",
        name: "IbUpLevel",
        component: IbUpLevel,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/rate",
        name: "Rate",
        component: Rate,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },
    {
        path: "/updaterate",
        name: "UpdateRate",
        component: UpdateRate,
        meta: {
            middleware: [auth, vendor_notcomplete]
        }
    },

]